import React, { useState, useEffect, useRef } from 'react'; // Adiciona useRef
import { Container, Row, Col, Tabs, Tab, Form, Button, ListGroup, Badge, Card, Modal, Alert, Table, Spinner, InputGroup, Image } from 'react-bootstrap'; // Adicionado InputGroup e Image
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../index.css'; // Import a CSS file for styling (create one if you don't have it)
import { useEntidadeContext } from '../EntidadeContext';
import { useUserContext } from '../UserContext'; // Importar o contexto do usuário
import logoImage from '../img/logo.png'; // Importa a imagem da logo

import ColaboradoresTab from '../components/pessoal/ColaboradoresTab'; // Importar o novo componente
import FolhaPagamentoTab from '../components/pessoal/FolhaPagamentoTab';

const formatCurrency = (value) => {
  // Ensure value is a number before formatting
  const numericValue = parseFloat(value);
  if (isNaN(numericValue)) return 'R$ 0,00';
  return numericValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};



const PessoalPage = () => {

  const navigate = useNavigate();
  const { currentUserRole, getPermittedInternalTabs, isLoadingAccessConfig, dynamicAccessConfig } = useUserContext(); // Obter estados do contexto
  const { currentEntidade, isLoadingEntidade } = useEntidadeContext(); // Adiciona isLoadingEntidade

  const [setores, setSetores] = useState([]);
  const [allFuncionarios, setAllFuncionarios] = useState([]);
  const [especialidades, setEspecialidades] = useState([]);
  const [perfis, setPerfis] = useState([]); // Novo estado para perfis

  // Modal states
  const [showFuncionarioModal, setShowFuncionarioModal] = useState(false);
  const [isEditingFuncionario, setIsEditingFuncionario] = useState(false);
  const [funcionarioToEdit, setFuncionarioToEdit] = useState(null);
  const [creatingSetor, setCreatingSetor] = useState(false);
  const [creatingCargo, setCreatingCargo] = useState(false);
  const [creatingFuncionario, setCreatingFuncionario] = useState(false);

  // States for backend messages
  const [setorMessage, setSetorMessage] = useState(null);
  const [cargoMessage, setCargoMessage] = useState(null);
  const [funcionarioMessage, setFuncionarioMessage] = useState(null);

  // Modal form states
  const [selectedSetorModal, setSelectedSetorModal] = useState('');
  const [cargosDoSetorModal, setCargosDoSetorModal] = useState([]);
  const [isLoadingCargosModal, setIsLoadingCargosModal] = useState(false);

  // Loading states for each delete action
  const [deletingSetor, setDeletingSetor] = useState(false);
  const [deletingCargo, setDeletingCargo] = useState(false);
  const [deletingFuncionario, setDeletingFuncionario] = useState(false);
  const [isLoadingFuncionarios, setIsLoadingFuncionarios] = useState(false);

  // Flag para controlar a busca inicial de dados
  const fetchDataAttemptedInThisMount = useRef(false);

  // Estados para Lançamentos Variáveis da Folha
  const [selectedFuncionarioLancamento, setSelectedFuncionarioLancamento] = useState(''); // ID do funcionário selecionado
  const [mesLancamento, setMesLancamento] = useState(new Date().getMonth() + 1); // Mês atual
  const [anoLancamento, setAnoLancamento] = useState(new Date().getFullYear()); // Ano atual
  const [lancamentosVariaveis, setLancamentosVariaveis] = useState([]);
  const [isLoadingLancamentos, setIsLoadingLancamentos] = useState(false);
  const [lancamentoMessage, setLancamentoMessage] = useState(null);
  
  // Estados para o NOVO Modal de Lançamentos Variáveis
  const [showLancamentoVariavelModal, setShowLancamentoVariavelModal] = useState(false);
  const [currentLancamentoVariavel, setCurrentLancamentoVariavel] = useState(null); // Para edição
  const [newLancamentoVariavelData, setNewLancamentoVariavelData] = useState({
    descricao: '',
    tipo: 'provento',
    valor: '',
    referencia: '',
  });
  // Estados para a Folha de Pagamento
  const [mesFolha, setMesFolha] = useState(new Date().getMonth() + 1); // Mês atual
  const [anoFolha, setAnoFolha] = useState(new Date().getFullYear()); // Ano atual
  const [dadosFolhaPagamento, setDadosFolhaPagamento] = useState([]);
  const [isLoadingFolha, setIsLoadingFolha] = useState(false);
  const [resumoFolha, setResumoFolha] = useState({ totalBruto: 0, totalDescontos: 0, totalLiquido: 0 });
  const [isProcessingFolhaFinal, setIsProcessingFolhaFinal] = useState(false);

  const [showDetalhesHoleriteModal, setShowDetalhesHoleriteModal] = useState(false);
  const [holeriteSelecionadoDetalhes, setHoleriteSelecionadoDetalhes] = useState(null);
  const [isLoadingDetalhesHolerite, setIsLoadingDetalhesHolerite] = useState(false);

  // Obter abas permitidas para Pessoal
  const permittedTabs = React.useMemo(() => {
    return getPermittedInternalTabs('pessoal', currentUserRole);
    },
    [getPermittedInternalTabs, currentUserRole, isLoadingAccessConfig, dynamicAccessConfig]
  );
  // Define a aba ativa inicial para a primeira permitida, ou 'colaboradores' como fallback
  const [activePessoalTab, setActivePessoalTab] = useState(permittedTabs[0]?.key || 'colaboradores');

  // Ajusta a aba ativa se a atual não for permitida para a role (useEffect)
  useEffect(() => {
    if (permittedTabs.length > 0 && !isLoadingAccessConfig && !permittedTabs.some(tab => tab.key === activePessoalTab)) { // Garante que o loading terminou
        setActivePessoalTab(permittedTabs[0].key);
    } }, [activePessoalTab, permittedTabs, isLoadingAccessConfig]); // Ajustadas dependências

  const [newFuncionarioData, setNewFuncionarioData] = useState({
    nome: '',
    cpf: '',
    email: '',
    dddcelular: '',
    celular: '',
    dddtelefone: '',
    telefone: '',
    data_nascimento: '',
    sexo: 'N', // Valor padrão
    estado_civil: 'Nao informado', // Valor padrão
    cor: 'Nao Informado', // Valor padrão
    mae: '',
    pai: '',
    cep: '',
    tipoendereco: 'Residencial', // Valor padrão
    estado: '',
    cidade: '',
    bairro: '',
    endereco: '',
    numero: '',
    complemento: '',
    obs: '',
    cargo_id: '', 
    salario_base: '', // Adicionado salario_base
    especialidade_id: null,
    tipo_contrato: 'CLT', // <<--- CORREÇÃO: Adicionado valor padrão
    comissionavel: false, // Novo campo para comissão
    comissionavel_origem: false, // NOVO CAMPO: Para comissão originária
    entidade_id: currentEntidade ? currentEntidade.id : null,
  });

  useEffect(() => {
    // Se esta é a segunda execução do useEffect pelo StrictMode NESTA montagem,
    // e a busca já foi tentada, OU se a entidade não carregou, não faz nada.
    if (fetchDataAttemptedInThisMount.current || !currentEntidade || isLoadingEntidade) {
      return;
    }

    setNewFuncionarioData(prev => ({ ...prev, entidade_id: currentEntidade.id }));

      const fetchInitialData = async () => {
        try {
          setIsLoadingFuncionarios(true);
          const [setoresRes, funcionariosRes, especialidadesRes, perfisRes] = await Promise.all([
            axios.get(`/api/setores?entidade_id=${currentEntidade.id}`),
            axios.get(`/api/funcionarios?entidade_id=${currentEntidade.id}`),
            axios.get('/api/especialidades'), // Geralmente especialidades são globais ou filtradas por entidade no backend
            axios.get(`/api/perfis?entidade_id=${currentEntidade.id}`) // Busca perfis
          ]);
          setSetores(setoresRes.data.setores || []);
          setAllFuncionarios(funcionariosRes.data.funcionarios || []);
          setEspecialidades(especialidadesRes.data.especialidades || []);
          setPerfis(perfisRes.data.perfis || []); // Armazena os perfis
        } catch (error) {
          console.error('Error fetching initial data:', error);
          setFuncionarioMessage({ type: 'danger', text: 'Erro ao carregar dados iniciais.' });
        } finally {
          setIsLoadingFuncionarios(false);
        }
      };

    // Marca que a tentativa de busca de dados para esta montagem está ocorrendo.
    fetchDataAttemptedInThisMount.current = true;

    if (currentEntidade && !isLoadingEntidade) { // Garante que a entidade esteja carregada
      fetchInitialData();
    }
  }, [currentEntidade, isLoadingEntidade]); // Adiciona isLoadingEntidade às dependências

  useEffect(() => {
    const fetchCargosBySetorModal = async () => {
      if (selectedSetorModal && currentEntidade) {
        setIsLoadingCargosModal(true);
        try {
          const response = await axios.get(`/api/setores/${selectedSetorModal}/cargos?entidade_id=${currentEntidade.id}`);
          setCargosDoSetorModal(response.data.cargos || []);
        } catch (error) {
          console.error('Error fetching cargos for modal:', error);
          setCargosDoSetorModal([]);
        } finally {
          setIsLoadingCargosModal(false);
        }
      } else {
        setCargosDoSetorModal([]);
      }
    };
    fetchCargosBySetorModal();
  }, [selectedSetorModal, currentEntidade]);


  const handleOpenFuncionarioModal = (funcionario = null) => {
    if (funcionario) {
      setIsEditingFuncionario(true);
      setFuncionarioToEdit(funcionario);
      setSelectedSetorModal(funcionario.cargo?.setor_id || ''); // Assumindo que a API retorna cargo.setor_id
      setNewFuncionarioData({
        ...funcionario,
        data_nascimento: funcionario.data_nascimento ? funcionario.data_nascimento.split('T')[0] : '',
        cargo_id: funcionario.cargo_id || '',
        salario_base: funcionario.salario_base || '', // Adicionado salario_base
        especialidade_id: funcionario.especialidade_id || null,
        comissionavel: funcionario.comissionavel || false, // Adicionado comissionavel
        comissionavel_origem: funcionario.comissionavel_origem || false, // NOVO CAMPO
        entidade_id: currentEntidade.id
      });
    } else {
      setIsEditingFuncionario(false);
      setFuncionarioToEdit(null);
      setSelectedSetorModal('');
      setCargosDoSetorModal([]);
      setNewFuncionarioData({
        nome: '', cpf: '', email: '', dddcelular: '', celular: '', dddtelefone: '', telefone: '',
        data_nascimento: '', sexo: 'N', estado_civil: 'Nao informado', cor: 'Nao Informado',
        mae: '', pai: '', cep: '', tipoendereco: 'Residencial', estado: '', cidade: '', tipo_contrato: 'CLT', // <<--- CORREÇÃO: Adicionado valor padrão
        bairro: '', endereco: '', numero: '', complemento: '', obs: '', salario_base: '', comissionavel: false, comissionavel_origem: false, // NOVO CAMPO
        cargo_id: '', especialidade_id: null, entidade_id: currentEntidade.id,
      });
    }
    setShowFuncionarioModal(true);
  };

  const handleCloseFuncionarioModal = () => {
    setShowFuncionarioModal(false);
    setIsEditingFuncionario(false);
    setFuncionarioToEdit(null);
    setFuncionarioMessage(null);
  };

  const handleFuncionarioInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewFuncionarioData({
      ...newFuncionarioData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSaveFuncionario = async () => {
    if (!newFuncionarioData.cargo_id) {
      setFuncionarioMessage({ type: 'danger', text: 'Por favor, selecione um setor e um cargo.' });
      return;
    }
    if (!currentEntidade) {
        setFuncionarioMessage({ type: 'danger', text: 'Entidade não identificada.' });
        return;
    }

    const dataPayload = {
        ...newFuncionarioData,
        entidade_id: currentEntidade.id,
        data_nascimento: newFuncionarioData.data_nascimento || null, // Enviar null se vazio
    };

    try {
      setCreatingFuncionario(true);
      setFuncionarioMessage(null);
      let response;
      if (isEditingFuncionario && funcionarioToEdit) {
        response = await axios.put(`/api/funcionarios/${funcionarioToEdit.id}`, dataPayload);
        setAllFuncionarios(allFuncionarios.map(f => f.id === funcionarioToEdit.id ? response.data.funcionario : f));
        setFuncionarioMessage({ type: 'success', text: response.data.message || 'Funcionário atualizado com sucesso!' });
      } else {
        response = await axios.post('/api/funcionarios', dataPayload);
        setAllFuncionarios([...allFuncionarios, response.data.funcionario]);
        setFuncionarioMessage({ type: 'success', text: response.data.message || 'Funcionário criado com sucesso!' });
      }
      handleCloseFuncionarioModal();
      // Refetch all funcionarios to ensure list is up-to-date with potential backend changes
      const funcionariosRes = await axios.get(`/api/funcionarios?entidade_id=${currentEntidade.id}`);
      setAllFuncionarios(funcionariosRes.data.funcionarios || []);
    } catch (error) {
      console.error('Error creating funcionario:', error);
      setFuncionarioMessage({ type: 'danger', text: error.response?.data?.message || 'Erro ao criar funcionário.' });
    } finally {
        setCreatingFuncionario(false);
    }
  };

  const handleDeleteFuncionario = async (funcionarioId) => {
    try {
      setDeletingFuncionario(true);
      setFuncionarioMessage(null);
      const response = await axios.delete(`/api/funcionarios/${funcionarioId}`);
      setAllFuncionarios(allFuncionarios.filter(f => f.id !== funcionarioId));
      setFuncionarioMessage({ type: 'success', text: response.data.message || 'Funcionário excluído com sucesso!' });
    } catch (error) {
      console.error('Error deleting funcionario:', error);
      setFuncionarioMessage({ type: 'danger', text: error.response?.data?.message || 'Erro ao excluir funcionário.' });
    } finally {
      setDeletingFuncionario(false);
    }
  };

  // Função para BUSCAR uma folha de pagamento existente
  const fetchFolhaPagamentoExistente = async (mes, ano, entidadeId) => {
    setIsLoadingFolha(true);
    setDadosFolhaPagamento([]);
    setResumoFolha({ totalBruto: 0, totalDescontos: 0, totalLiquido: 0, statusFolha: 'Pendente' });
    try {
      const response = await axios.get('/api/folha-pagamento', {
        params: {
          entidade_id: entidadeId,
          mes: mes,
          ano: ano,
        }
      });
      setDadosFolhaPagamento(response.data.dadosFolha || []);
      setResumoFolha(response.data.resumoFolha || { totalBruto: 0, totalDescontos: 0, totalLiquido: 0, statusFolha: 'Pendente' });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        // Folha não encontrada, o que é esperado se ainda não foi gerada
        setDadosFolhaPagamento([]);
        setResumoFolha({ totalBruto: 0, totalDescontos: 0, totalLiquido: 0, statusFolha: 'NaoGerada' });
      } else {
        console.error('Erro ao buscar folha de pagamento existente:', error);
        alert(`Erro ao buscar folha: ${error.response?.data?.message || error.message}`);
      }
    } finally {
      setIsLoadingFolha(false);
    }
  };

  // Efeito para buscar a folha ao mudar o período ou a entidade
  useEffect(() => {
    if (currentEntidade && activePessoalTab === 'folhaPagamento') {
      fetchFolhaPagamentoExistente(mesFolha, anoFolha, currentEntidade.id);
    }
  }, [mesFolha, anoFolha, currentEntidade, activePessoalTab]);


  const handleGerarOuVisualizarFolha = async () => {
    if (!currentEntidade) {
      alert("Entidade não carregada. Não é possível gerar a folha.");
      return;
    }
    // Se a folha não existe ou está pendente, tenta gerar. Caso contrário, apenas busca novamente (refresh).
    if (resumoFolha?.statusFolha === 'NaoGerada' || resumoFolha?.statusFolha === 'Pendente' || resumoFolha?.statusFolha === 'Em Processamento') {
      setIsLoadingFolha(true);
      const gerarResponse = await axios.post('/api/folha-pagamento/gerar', {
        entidade_id: currentEntidade.id,
        mes: mesFolha,
        ano: anoFolha,
      });

      if (gerarResponse.status === 201 || gerarResponse.status === 200) { // 201 para criada, 200 se já existia e foi atualizada
        fetchFolhaPagamentoExistente(mesFolha, anoFolha, currentEntidade.id); // Busca os dados após gerar
      } else {
        alert(`Erro ao gerar folha: ${gerarResponse.data.message || 'Status inesperado.'}`);
        setIsLoadingFolha(false);
      }
    } else {
      // Se a folha já está 'Processada' ou 'Paga', apenas faz um refresh dos dados.
      fetchFolhaPagamentoExistente(mesFolha, anoFolha, currentEntidade.id);
    }
  };

  const handleProcessarFolhaFinal = async () => {
    if (!currentEntidade || !resumoFolha || dadosFolhaPagamento.length === 0) {
      alert("Não há uma folha gerada para processar ou entidade não carregada.");
      return;
    }

    if (window.confirm(`Tem certeza que deseja processar e finalizar a folha de ${String(mesFolha).padStart(2, '0')}/${anoFolha}? Esta ação geralmente não pode ser desfeita.`)) {
      setIsProcessingFolhaFinal(true);
      try {
        const response = await axios.post('/api/folha-pagamento/processar-final', {
          entidade_id: currentEntidade.id,
          mes: mesFolha,
          ano: anoFolha,
        });

        if (response.status === 200) {
          alert(response.data.message || "Folha processada com sucesso!");
          // Atualiza o status da folha no resumo e nos itens
          setResumoFolha(prev => ({ ...prev, statusFolha: response.data.folhaPagamento?.status || 'Paga' }));
          setDadosFolhaPagamento(prevDados => prevDados.map(item => ({ ...item, status: response.data.folhaPagamento?.status || 'Paga' })));
        } else {
          alert(`Erro ao processar folha: ${response.data.message || 'Status inesperado.'}`);
        }
      } catch (error) {
        console.error('Erro ao processar folha final:', error);
        alert(`Erro ao processar folha: ${error.response?.data?.message || error.message}`);
      } finally {
        setIsProcessingFolhaFinal(false);
      }
    }
  };

  // --- Lógica para Lançamentos Variáveis (Funções Globais no Componente) ---
  const handleFetchLancamentos = async (funcionarioIdToFetch) => {
    // Usa o ID do funcionário passado como parâmetro
    if (!funcionarioIdToFetch || !currentEntidade) {

      setLancamentosVariaveis([]);
      // Não definir mensagem aqui para não sobrescrever mensagens de sucesso/erro de outras operações
      // A aba de lançamentos pode ter sua própria lógica de mensagem se nenhum funcionário for selecionado.
      return;
    }
    setIsLoadingLancamentos(true);
    // Não limpar lancamentoMessage aqui para não apagar feedback de save/delete
    try {
      const response = await axios.get(`/api/funcionarios/${funcionarioIdToFetch}/lancamentos-variaveis`, { // Usa funcionarioIdToFetch na URL
        params: { 
          entidade_id: currentEntidade.id,
          mes: mesLancamento, 
          ano: anoLancamento, 
        }
      });
      setLancamentosVariaveis(response.data || []);
      // A mensagem de "nenhum lançamento" pode ser tratada na UI da aba ou do modal
    } catch (error) {
      console.error('Erro ao buscar lançamentos variáveis:', error);
      setLancamentoMessage({ type: 'danger', text: error.response?.data?.message || 'Erro ao buscar lançamentos variáveis.' });
      setLancamentosVariaveis([]);
    } finally {
      setIsLoadingLancamentos(false);
    }
  };

  // --- Lógica para o NOVO Modal de Lançamentos Variáveis ---
  const handleOpenNovoLancamentoModal = (funcionario, lancamento = null) => {
    setSelectedFuncionarioLancamento(funcionario.id);
    if (lancamento) {
      setCurrentLancamentoVariavel(lancamento);
      setNewLancamentoVariavelData({
        descricao: lancamento.descricao,
        tipo: lancamento.tipo,
        valor: lancamento.valor,
        referencia: lancamento.referencia || '',
      });
    } else {
      setCurrentLancamentoVariavel(null);
      setNewLancamentoVariavelData({
        descricao: '',
        tipo: 'provento',
        valor: '',
        referencia: '',
      });
    }
    handleFetchLancamentos(funcionario.id); 
    setShowLancamentoVariavelModal(true);
  };

  const handleCloseNovoLancamentoModal = () => {
    setShowLancamentoVariavelModal(false);
    setCurrentLancamentoVariavel(null);
    setLancamentoMessage(null); 
  };

  const handleLancamentoVariavelInputChange = (e) => {
    const { name, value } = e.target;
    setNewLancamentoVariavelData(prev => ({ ...prev, [name]: value }));
  };

  const handleSaveNovoLancamentoVariavel = async () => {
    // ... (código da função handleSaveNovoLancamentoVariavel como estava antes)
    // Certifique-se que a chamada a handleFetchLancamentos aqui esteja correta:
    // handleFetchLancamentos(selectedFuncionarioLancamento);
    // ... (resto do código da função)
    if (!selectedFuncionarioLancamento || !currentEntidade) {
      setLancamentoMessage({ type: 'danger', text: 'Funcionário ou entidade não selecionados.' });
      return;
    }
    if (!newLancamentoVariavelData.descricao || !newLancamentoVariavelData.valor) {
        setLancamentoMessage({ type: 'danger', text: 'Descrição e Valor são obrigatórios.' });
        return;
    }

    const url = currentLancamentoVariavel
      ? `/api/lancamentos-variaveis/${currentLancamentoVariavel.id}`
      : '/api/lancamentos-variaveis';
    const method = currentLancamentoVariavel ? 'put' : 'post';

    const payload = {
      funcionario_id: selectedFuncionarioLancamento,
      entidade_id: currentEntidade.id,
      mes: mesLancamento, 
      ano: anoLancamento, 
      descricao: newLancamentoVariavelData.descricao,
      tipo: newLancamentoVariavelData.tipo,
      valor: parseFloat(newLancamentoVariavelData.valor),
      referencia: newLancamentoVariavelData.referencia,
    };

    try {
      await axios[method](url, payload);
      setLancamentoMessage({ type: 'success', text: `Lançamento ${currentLancamentoVariavel ? 'atualizado' : 'salvo'} com sucesso!` });
      handleFetchLancamentos(selectedFuncionarioLancamento); 
      handleCloseNovoLancamentoModal();
    } catch (error) {
      console.error('Erro ao salvar lançamento variável:', error);
      setLancamentoMessage({ type: 'danger', text: error.response?.data?.message || 'Erro ao salvar lançamento.' });
    }
  };

  const handleDeleteLancamento = async (lancamentoId) => {
    if (window.confirm('Tem certeza que deseja excluir este lançamento?')) {
      try {
        await axios.delete(`/api/lancamentos-variaveis/${lancamentoId}`);
        setLancamentoMessage({ type: 'success', text: 'Lançamento excluído com sucesso!' });
        if (selectedFuncionarioLancamento) { 
          handleFetchLancamentos(selectedFuncionarioLancamento); 
        }
      } catch (error) {
        console.error('Erro ao excluir lançamento:', error);
        setLancamentoMessage({ type: 'danger', text: error.response?.data?.message || 'Erro ao excluir lançamento.' });
      }
    }
  };

  // useEffect para buscar lançamentos quando o funcionário/período/entidade muda na aba de lançamentos
  useEffect(() => {
    if (activePessoalTab === 'lancamentosVariaveis' && selectedFuncionarioLancamento && currentEntidade) {
      handleFetchLancamentos(selectedFuncionarioLancamento); // Passa o ID do estado
    } else if (activePessoalTab === 'lancamentosVariaveis' && !selectedFuncionarioLancamento) {
       setLancamentosVariaveis([]);
       setLancamentoMessage({ type: 'info', text: 'Selecione um funcionário e período para buscar lançamentos.' });
    }
  }, [activePessoalTab, selectedFuncionarioLancamento, mesLancamento, anoLancamento, currentEntidade]);

    // --- Lógica para o Modal de Detalhes do Holerite ---
  const handleOpenDetalhesHoleriteModal = async (itemFolha) => {
    // 'itemFolha' é o objeto do funcionário vindo de 'dadosFolhaPagamento'
    // Vamos assumir que 'itemFolha' já contém os lançamentos ou um ID para buscá-los.
    // Para esta implementação, vamos simular que os lançamentos já estão em 'itemFolha.lancamentos'
    // Se não estiverem, você precisará fazer uma chamada API aqui para buscar os detalhes do holerite.

    setIsLoadingDetalhesHolerite(true);
    // Simulação de busca de detalhes (se necessário)
    // await new Promise(resolve => setTimeout(resolve, 500)); 

    // Exemplo de como seria se você precisasse buscar os lançamentos:
    // try {
    //   const response = await axios.get(`/api/holerites/${itemFolha.holerite_id_real_do_banco}/detalhes`);
    //   setHoleriteSelecionadoDetalhes(response.data);
    // } catch (error) {
    //   console.error("Erro ao buscar detalhes do holerite:", error);
    //   setHoleriteSelecionadoDetalhes({ ...itemFolha, lancamentos: [] }); // Fallback
    // }
    
    // Usa os lançamentos que vêm da API (itemFolha.lancamentos). A comissão será um desses lançamentos.
    // O objeto `itemFolha` já contém os totais (salarioBase, adicionais, etc.) que são calculados no backend.
    setHoleriteSelecionadoDetalhes({ ...itemFolha });
    setIsLoadingDetalhesHolerite(false);
    setShowDetalhesHoleriteModal(true);
  };

  const handleCloseDetalhesHoleriteModal = () => {
    setShowDetalhesHoleriteModal(false);
    setHoleriteSelecionadoDetalhes(null);
  };

  const handlePrintHolerite = () => {
    window.print();
  };


  return (
    <div style={{ border: '1px solid gray', backgroundColor: '#f5f5f5' }}>
      <div className="header" style={{ minHeight: '80px' }}>
        <Row className="p-1 align-items-center" style={{ minHeight: 'inherit' }}>
          <Col xs={12} md={6} style={{ minHeight: '60px' }}>
            <div className="d-flex align-items-center justify-content-start h-100">
              <Image src={logoImage} alt="Logo Clínica" style={{ maxHeight: '60px', marginLeft: '12px' }} />
              <h3 style={{ marginLeft: '15px', marginBottom: '0' }}>Gestão de Pessoal</h3>
            </div>
          </Col>
          <Col xs={12} md={6} className="text-end">
          </Col>
        </Row>
      </div>
      <div className="body p-3">
        <Tabs activeKey={activePessoalTab} onSelect={(k) => setActivePessoalTab(k)} className="mb-3">
          {permittedTabs.map(tab => {
            let tabContent = null;

              if (tab.key === 'colaboradores') {
                tabContent = (
                <ColaboradoresTab
                  allFuncionarios={allFuncionarios}
                  isLoadingFuncionarios={isLoadingFuncionarios}
                  funcionarioMessage={funcionarioMessage}
                  setFuncionarioMessage={setFuncionarioMessage}
                  handleOpenFuncionarioModal={handleOpenFuncionarioModal}
                  handleDeleteFuncionario={handleDeleteFuncionario}
                  deletingFuncionario={deletingFuncionario}
                  handleOpenNovoLancamentoModal={handleOpenNovoLancamentoModal}
                  // Props para o Modal de Funcionário
                  showFuncionarioModal={showFuncionarioModal}
                  handleCloseFuncionarioModal={handleCloseFuncionarioModal}
                  isEditingFuncionario={isEditingFuncionario}
                  newFuncionarioData={newFuncionarioData}
                  handleFuncionarioInputChange={handleFuncionarioInputChange}
                  handleSaveFuncionario={handleSaveFuncionario}
                  creatingFuncionario={creatingFuncionario}
                  selectedSetorModal={selectedSetorModal}
                  setSelectedSetorModal={setSelectedSetorModal}
                  setores={setores}
                  cargosDoSetorModal={cargosDoSetorModal}
                  isLoadingCargosModal={isLoadingCargosModal}
                  especialidades={especialidades}
                  perfis={perfis} // Passa os perfis para ColaboradoresTab
                  setNewFuncionarioData={setNewFuncionarioData}
                  />
                )
              } else if (tab.key === 'folhaPagamento') {
                tabContent = (
                  <FolhaPagamentoTab
                    mesFolha={mesFolha}
                    setMesFolha={setMesFolha}
                    anoFolha={anoFolha}
                    setAnoFolha={setAnoFolha}
                    dadosFolhaPagamento={dadosFolhaPagamento}
                    isLoadingFolha={isLoadingFolha}
                    resumoFolha={resumoFolha}
                    isProcessingFolhaFinal={isProcessingFolhaFinal}
                    handleGerarOuVisualizarFolha={handleGerarOuVisualizarFolha}
                    handleProcessarFolhaFinal={handleProcessarFolhaFinal}
                    handleOpenDetalhesHoleriteModal={handleOpenDetalhesHoleriteModal}
                  />
                )
              } else if (tab.key === 'controlePonto') {
              } else if (tab.key === 'feriasLicencas') {
              } else if (tab.key === 'beneficios') {
              } else if (tab.key === 'recrutamento') {
              } else if (tab.key === 'treinamentos') {
              } else if (tab.key === 'avaliacaoDesempenho') {
              } else if (tab.key === 'relatoriosRH') {
              }
            return (
              <Tab
                key={tab.key}
                eventKey={tab.key}
                title={tab.title}
              >
                {tabContent}
              </Tab>
            );
          })}

        </Tabs>
      </div>
      
      <Modal show={showLancamentoVariavelModal} onHide={handleCloseNovoLancamentoModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            {currentLancamentoVariavel ? 'Editar Lançamento Variável' : 'Novo Lançamento Variável'}
            {selectedFuncionarioLancamento && allFuncionarios.find(f => f.id === selectedFuncionarioLancamento) &&
              <small className="d-block text-muted">
                Funcionário: {allFuncionarios.find(f => f.id === selectedFuncionarioLancamento).nome} | Período: {String(mesLancamento).padStart(2, '0')}/{anoLancamento}
              </small>
            }
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {lancamentoMessage && <Alert variant={lancamentoMessage.type} onClose={() => setLancamentoMessage(null)} dismissible>{lancamentoMessage.text}</Alert>}
          <h5 className="mb-3">{currentLancamentoVariavel ? 'Editar Lançamento' : 'Adicionar Novo Lançamento'}</h5>
          <Form onSubmit={(e) => { e.preventDefault(); handleSaveNovoLancamentoVariavel(); }} className="mb-4">
            <Row>
              <Col md={12}>
                <Form.Group className="mb-3" controlId="lancamentoDescricaoModal">
                  <Form.Label>Descrição *</Form.Label>
                  <Form.Control type="text" name="descricao" value={newLancamentoVariavelData.descricao} onChange={handleLancamentoVariavelInputChange} required />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={5}>
                <Form.Group className="mb-3" controlId="lancamentoTipoModal">
                  <Form.Label>Tipo *</Form.Label>
                  <Form.Select name="tipo" value={newLancamentoVariavelData.tipo} onChange={handleLancamentoVariavelInputChange} required>
                    <option value="provento">Provento</option>
                    <option value="desconto">Desconto</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={7}>
                <Form.Group className="mb-3" controlId="lancamentoValorModal">
                  <Form.Label>Valor (R$) *</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>R$</InputGroup.Text>
                    <Form.Control type="number" step="0.01" name="valor" value={newLancamentoVariavelData.valor} onChange={handleLancamentoVariavelInputChange} required min="0" placeholder="0.00"/>
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Form.Group className="mb-3" controlId="lancamentoReferenciaModal">
                  <Form.Label>Referência</Form.Label>
                  <Form.Control type="text" name="referencia" value={newLancamentoVariavelData.referencia} onChange={handleLancamentoVariavelInputChange} />
                </Form.Group>
              </Col>
            </Row>
            <div className="d-flex justify-content-end">
              {currentLancamentoVariavel && (
                <Button variant="outline-secondary" className="me-2" onClick={() => {
                  setCurrentLancamentoVariavel(null);
                  setNewLancamentoVariavelData({ descricao: '', tipo: 'provento', valor: '', referencia: '' });
                }}>
                  Cancelar Edição
                </Button>
              )}
              <Button variant="primary" type="submit">
                {currentLancamentoVariavel ? 'Atualizar Lançamento' : 'Adicionar Lançamento'}
              </Button>
            </div>
          </Form>

          <hr />
          <h5>Lançamentos Existentes para o Período</h5>
          {isLoadingLancamentos ? (
            <div className="text-center"><Spinner animation="border" size="sm" /></div>
          ) : lancamentosVariaveis.length > 0 ? (
            <Table striped bordered hover responsive size="sm">
              <thead>
                <tr><th>Descrição</th><th>Tipo</th><th>Valor (R$)</th><th>Referência</th><th>Ações</th></tr>
              </thead>
              <tbody>
                {lancamentosVariaveis.map(lanc => (
                  <tr key={lanc.id}>
                    <td>{lanc.descricao}</td>
                    <td>{lanc.tipo === 'provento' ? 'Provento' : 'Desconto'}</td>
                    <td className="text-end">{parseFloat(lanc.valor).toFixed(2)}</td>
                    <td>{lanc.referencia || '-'}</td>
                    <td className="text-center" style={{ whiteSpace: 'nowrap' }}> 
                      <Button variant="outline-warning" size="sm" className="me-1 py-0 px-2" onClick={() => handleOpenNovoLancamentoModal(allFuncionarios.find(f => f.id === selectedFuncionarioLancamento), lanc)} title="Editar Lançamento">E</Button>
                      {' '} 
                      <Button variant="outline-danger" size="sm" className="py-0 px-2" onClick={() => { handleDeleteLancamento(lanc.id); }} title="Excluir Lançamento">X</Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <p>Nenhum lançamento encontrado para este funcionário e período.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseNovoLancamentoModal}>Fechar</Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showDetalhesHoleriteModal} onHide={handleCloseDetalhesHoleriteModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Holerite</Modal.Title>
        </Modal.Header>
        <Modal.Body className="printable-content">
          {isLoadingDetalhesHolerite ? (
            <div className="text-center"><Spinner animation="border" /></div>
          ) : holeriteSelecionadoDetalhes ? (
            <>
              <div className="text-left mb-4 pb-2 border-bottom">
                <h4 className="mb-1">{currentEntidade?.nome}</h4>
                <p className="text-muted mb-0">CNPJ: {currentEntidade?.cnpj}</p>
              </div>
              <h5>Funcionário: {holeriteSelecionadoDetalhes.nome}</h5>
              <p>Cargo: {holeriteSelecionadoDetalhes.cargo}</p>
              <p>Período: {String(mesFolha).padStart(2, '0')}/{anoFolha}</p>
              <hr />
              <Table responsive size="sm">
                <thead>
                  <tr>
                    <th>Descrição do Evento</th>
                    <th className="text-end">Proventos (R$)</th>
                    <th className="text-end">Descontos (R$)</th>
                  </tr>
                </thead>
                <tbody>
                  {holeriteSelecionadoDetalhes.lancamentos?.map((lanc, index) => (
                    <tr key={lanc.id || index}>
                      <td>{lanc.descricao_evento_historico || lanc.descricao}</td>
                      <td className="text-end">{lanc.tipo_evento_historico === 'provento' ? formatCurrency(lanc.valor_calculado) : '-'}</td>
                      <td className="text-end">{lanc.tipo_evento_historico === 'desconto' ? formatCurrency(lanc.valor_calculado) : '-'}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="fw-bold">
                    <td>TOTAIS</td>
                    <td className="text-end">{formatCurrency(holeriteSelecionadoDetalhes.total_proventos)}</td>
                    <td className="text-end">{formatCurrency(holeriteSelecionadoDetalhes.totalDescontos)}</td>
                  </tr>
                  <tr>
                    <td colSpan="2" className="text-end fw-bold">VALOR LÍQUIDO:</td>
                    <td className="text-end fw-bold">R$ {parseFloat(holeriteSelecionadoDetalhes.valorLiquido).toFixed(2)}</td>
                  </tr>
                </tfoot>
              </Table>
            </>
          ) : <p>Nenhum detalhe para exibir.</p>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDetalhesHoleriteModal}>Fechar</Button>          
          <Button variant="primary" onClick={handlePrintHolerite}>Imprimir</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PessoalPage;
